import $ from 'jquery';

$(document).ready(() => {
	$('.navbar-toggler').on('click', (event) => {
		event.preventDefault();
		const $btn = $(event.currentTarget);
		$btn.toggleClass('is-active');
		$($btn.data('nav-target')).toggleClass('show');
	});
	$(window).bind('scroll', (event) => {
		const $header = $('header.header');
		$header.toggleClass('in', $(window).scrollTop() > 300);
	});
});



// WEBPACK FOOTER //
// ./src/js/components/nav.js